<mat-form-field>
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput [type]="type" [value]="searchText" [formControl]="searchControl" admClearTextDirective />
  @if (displaySearchIcon && !searchText) {
    <mat-icon matSuffix>search</mat-icon>
  } @else if (searchText) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="reset()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
